import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const NormalText = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          opacity="0.98"
          d="M1.4125 17.139C1.75824 17.139 2.06434 16.9155 2.16964 16.5862L3.32426 12.9755H8.67568L9.8303 16.5862C9.93561 16.9155 10.2417 17.139 10.5875 17.139V17.139C11.1292 17.139 11.5122 16.6089 11.3422 16.0945L7.08692 3.22301C6.93192 2.75417 6.49377 2.43755 5.99997 2.43755V2.43755C5.50618 2.43755 5.06803 2.75417 4.91303 3.22301L0.657757 16.0945C0.487708 16.6089 0.870747 17.139 1.4125 17.139V17.139ZM3.82838 11.3962L5.94827 4.76336H6.05168L8.17156 11.3962H3.82838Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8407 10.1626C14.291 9.50354 15.0377 9.10938 15.8359 9.10938H16.4077C17.0981 9.10938 17.6577 9.66902 17.6577 10.3594V10.3639C17.6541 10.6812 17.4242 10.9512 17.1107 11.0049L14.4793 11.4554C13.0471 11.7007 12 12.9423 12 14.3954C12 15.9105 13.2283 17.1389 14.7435 17.1389H15.1046C16.0583 17.1389 16.9534 16.8038 17.6577 16.2287V16.3888C17.6577 16.8031 17.9935 17.1388 18.4077 17.1388C18.8219 17.1388 19.1577 16.8031 19.1577 16.3888V13.0176C19.1578 13.011 19.1578 13.0045 19.1578 12.9979V11.6531C19.1578 11.6503 19.1578 11.6476 19.1577 11.6448V10.3701C19.1578 10.3655 19.1578 10.3608 19.1578 10.3562C19.1578 10.3525 19.1577 10.3488 19.1577 10.3451C19.15 8.83288 17.9217 7.60938 16.4077 7.60938H15.8359C14.5422 7.60938 13.332 8.24821 12.6022 9.31636C12.3685 9.65836 12.4563 10.125 12.7983 10.3587C13.1403 10.5924 13.607 10.5046 13.8407 10.1626ZM17.6577 12.4117V13.0139C17.656 13.3195 17.6054 13.623 17.5078 13.9127C17.1602 14.9442 16.1931 15.6389 15.1046 15.6389H14.7435C14.0567 15.6389 13.5 15.0821 13.5 14.3954C13.5 13.673 14.0205 13.0558 14.7325 12.9339L17.3639 12.4834C17.4646 12.4661 17.5627 12.442 17.6577 12.4117Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default NormalText
